export const compoundingReasons = [
  'Drug Shortage or Backorder',
  'Commercially Available Product Discontinued',
  'Modified Release',
  'Inactive Ingredient Sensitivity/Allergy',
  'Inactive Ingredient Toxic to Species',
  'Concentration Adjustment Necessary',
  'Alternate Administration Route',
  'Patient Noncompliance',
  'Alcohol Free',
  'No Rationale Required',
];
